import api from '../config/api';

const getChecklistStationReport = (stationId: any, eventId: any) => {
  return api.get(`reports/checklist/station/${stationId}`, {
    params: { event_id: eventId },
    responseType: 'blob',
  });
};

const ReportsService = {
  getChecklistStationReport,
};

export default ReportsService;
